import $ from 'jquery'

const shopReview = function () {
    let windowWidth = $('body').get(0).clientWidth,
        pageWidth = 1190,
        fixcard = $('.J-goverment');
    if (fixcard.length) {
        // fixcardWidth元素宽度， sideWidth 侧边栏宽度
        let fixcardWidth = fixcard.outerWidth(),
            sideWidth = (windowWidth - pageWidth) / 2,
            right = 0;
        // 右边有余量，靠左侧边栏15px
        if (sideWidth - fixcardWidth - 15 > 0) {
            right = sideWidth - fixcardWidth - 15;
        }
        fixcard.css({
            right: right
        })
        fixcard.on('click', function(){
            window.open('http://shwg.dianping.com')
        })
    }
}

const govCard = {
    init: () => {
        // 网购大家评模块
        shopReview()
    }
}

export default govCard;



// WEBPACK FOOTER //
// ./modules/cate-nav-index/js/gov-card.js